import {
  useEdiMessageTypesQuery,
  IEdiMessageTypesQueryVariables,
} from '../graphql/InboundEdiMessageTypesWithConfig'
import { processEdiMessageTypes } from '../utils'

export const useEdiMessageType = ({
  connectionConfigIds,
  connectionConfigType,
}: IEdiMessageTypesQueryVariables) => {
  const { data, loading } = useEdiMessageTypesQuery({
    variables: {
      connectionConfigType,
      connectionConfigIds,
    },
    skip: !(connectionConfigType && connectionConfigIds),
  })

  const ediMessageTypes = processEdiMessageTypes(data)

  return {
    ediMessageTypes,
    loading,
  }
}
